import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MonitorSmartphone, ShieldAlert, HardDrive } from "lucide-react";

export default function ITAssetsPage() {
  const [assets, setAssets] = useState([]);
  const [tickets, setTickets] = useState([]);
  useEffect(() => {
    api.get("/it/assets").then((r)=>setAssets(r.data.items));
    api.get("/it/tickets").then((r)=>setTickets(r.data.items));
  }, []);
  const cols = ["open","in_progress","resolved","closed"];
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">IT Infrastructure</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Hardware Lifecycle & Helpdesk</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPI icon={HardDrive} label="Assets" value={assets.length}/>
        <KPI icon={MonitorSmartphone} label="Operational" value={assets.filter(a=>a.status==="operational").length}/>
        <KPI icon={ShieldAlert} label="Open Tickets" value={tickets.filter(t=>t.status==="open").length}/>
        <KPI icon={ShieldAlert} label="Critical" value={tickets.filter(t=>t.priority==="critical").length}/>
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <div className="font-heading font-semibold mb-3">IT Asset Register</div>
        <div className="overflow-x-auto max-h-80 overflow-y-auto">
          <table className="w-full">
            <thead className="sticky top-0 bg-card z-10">
              <tr>
                <th className="table-th">Asset</th>
                <th className="table-th">Type</th>
                <th className="table-th">Make/Model</th>
                <th className="table-th">Assigned</th>
                <th className="table-th">Warranty</th>
                <th className="table-th">Status</th>
              </tr>
            </thead>
            <tbody>
              {assets.map(a => (
                <tr key={a.id} className="border-t border-border">
                  <td className="table-cell font-mono">{a.asset_id}</td>
                  <td className="table-cell">{a.type}</td>
                  <td className="table-cell text-muted-foreground">{a.make} {a.model}</td>
                  <td className="table-cell">{a.assigned_to}</td>
                  <td className="table-cell text-xs text-muted-foreground">{a.warranty_expiry}</td>
                  <td className="table-cell"><span className={`stat-pill capitalize ${a.status === "operational" ? "bg-emerald-500/10 text-emerald-500" : a.status === "maintenance" ? "bg-amber-500/10 text-amber-500" : "bg-slate-500/10 text-slate-500"}`}>{a.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <div className="label-tiny mb-3">Helpdesk Board</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {cols.map((c) => (
            <div key={c} className="rounded-2xl bg-muted/40 p-3">
              <div className="flex items-center justify-between mb-3">
                <div className="font-heading font-semibold capitalize">{c.replace("_"," ")}</div>
                <span className="text-xs text-muted-foreground">{tickets.filter(t=>t.status===c).length}</span>
              </div>
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {tickets.filter(t=>t.status===c).map(t=>(
                  <div key={t.id} className="rounded-lg bg-card border border-border p-3">
                    <div className="flex items-center justify-between text-xs">
                      <span className="font-mono">{t.ticket_no}</span>
                      <span className={`stat-pill capitalize ${t.priority === "critical" ? "bg-red-500/10 text-red-500" : t.priority === "high" ? "bg-amber-500/10 text-amber-500" : "bg-sky-500/10 text-sky-500"}`}>{t.priority}</span>
                    </div>
                    <div className="mt-2 text-sm font-medium">{t.subject}</div>
                    <div className="text-xs text-muted-foreground mt-1">Assigned: {t.assigned_to} · {t.created_at}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function KPI({ icon: Icon, label, value }) {
  return (
    <div className="kpi-card">
      <div className="h-10 w-10 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center"><Icon className="h-5 w-5"/></div>
      <div className="mt-3 font-heading text-2xl font-bold">{value}</div>
      <div className="text-xs text-muted-foreground mt-1">{label}</div>
    </div>
  );
}
